<script lang="ts">
  import Page from '$components/page/Page.svelte';
  import Button from '$components/button/Button.svelte';
  import { goto } from '$app/navigation';
  import { page } from '$app/state';
  import { openModal } from '$components/bottom-sheet/index.svelte';
  import RestartApp from '$modals/restart-app/RestartApp.svelte';
  import { type AppError, ErrorType } from '$types/error';
  import { onMount } from 'svelte';
  import Image from '$lib/assets/error-icon.webp';
  import { stateError } from '$states/error.svelte';

  onMount(() => {
    stateError.set({
      type: ErrorType.SILENT,
      rawError: page.error as AppError,
      message: 'Client Crash with Error Page.',
      actions: [
        {
          action: (): Promise<void> => goto('/circles'),
          text: 'Reload App',
        },
      ],
    });
  });
  const reload = () => {
    return goto('/');
  };
</script>

<Page>
  {#snippet middle()}
    <div class="grid h-full place-items-center p-4">
      <div class="grid place-items-center gap-4">
        <img src={Image} alt="Metri - Error" class="h-[84px]" />
        <h5 class="text-center typography-body-l-semibold">An error occurred</h5>
        {#if page.error}
          {#if page.error.status === 404}
            <p class="text-center">The page you are looking for does not exist.</p>
          {:else if page.error.status === 500}
            <p class="text-center">
              We couldn’t display the page. Please reload or try again later.
            </p>
          {:else}
            <p class="text-center">
              We couldn’t display the page. Please reload or try again later.
            </p>
          {/if}
        {:else}
          <p>We couldn’t display the page. Please reload or try again later.</p>
        {/if}
      </div>
    </div>
  {/snippet}
  {#snippet bottom()}
    <div class="grid gap-4 p-4">
      <Button ariaLabel="Reload" variant="primary" onclick={reload}>Reload</Button>
      <Button ariaLabel="Reset the app" variant="plain" onclick={() => openModal(RestartApp)}
        >Reset the App</Button>
    </div>
  {/snippet}
</Page>
